import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { IncomeaddPageRoutingModule } from './incomeadd-routing.module';

import { IncomeaddPage } from './incomeadd.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    IncomeaddPageRoutingModule
  ],
  declarations: [IncomeaddPage]
})
export class IncomeaddPageModule {}
